// extracted by mini-css-extract-plugin
module.exports = {"SQLEditor":"SQLEditor_SQLEditor__16ROX","monacoEditor":"SQLEditor_monacoEditor__20jK8"};